import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  modelDataRowPosition: {},
  modelDataRow: [], //width,height,left,top
  pageEditorModelData1: '',
  displayAppTheme: false,
  showThemePreview: false,
  customThemeList: [],
  selectedThemeDtls: null,
  selectedWidget: null,
  currentPageDtls: null,
  errorMessage: null,
  successMessage: null,
  failureMessage: null,
  actionFlowList: [],
  actionFlowOutputParamsList: [],
  resourceAppConstants: [],
  userProfile: [],
  applicationDetails: {},
  device: 'Desktop',
  selectedThemeId: '',
  showLeftSidebar: true,
  showRightSidebar: true,
  defaultCanvasHeight: null,
  //defaultCanvasWidth: null,
  //leftRightWidth: null,
  currentCanvasWidth:0,
  leftSidebarWidth:0,
  rightSidebarWidth:0,
  copyWidgetDtls: null,
  zoomPercentage: 100,
  showNestedMenu: false,
  showPreSelectedNestedMenu: false,
  appTitle: '',
  appAliasName: '',
  validCustomDomain:'',
  sitemapDynamicUrls:[],
  appDescription:'',
  appKeywords:'',
  coverImage:'',
  appFavicon: '',
  gglAnlytcsMsrmntId: '',
  gglTagMngrId:'',
  fbPixelId:'',
  gglAdsPublisherId:'',
  gglAdUnitId:'',
  freeDomain:'',
  freeDomainReadOnly:'',
  customDomainReadOnly: '',
  customDomain: '',
  visiblePopup: '',
  visiblePopover: '',
  popoverMonitor: {},
  showMoreAppTempGroupName: '',
  deployModel:false,
  appModel : false,
  filteredWidget : '',
  searchWidgetName:'',
  pageLock: false,
  lnggTrnsltnNd:false,
  showCountryFlag:false,
  defLngg:{
    languageCode:'en',
    languageName:'English'
  },
  supLngg:[],
  canonicalUrlInfo:'',
  cookieEnabled: false,
  typeStrctData:'',
  seoStrctDataType:'',
  customSeoStrctData:'',
  sitemapAdditionalUrls:'',
  nameStrctData:'',
  tlphnStrctData:'',
  addrTypeStrctData:'',
  streetAddrStrctData:'',
  addrLcltyStrctData:'',
  pstlCdeStrctData:'',
  addrCuntyStrctData:'',
  opngHrsStructData:'',
  sameAsStructData:[""],
  moreOption: false,
  readOnly:{}
};

const pageEditorCanvasSlice = createSlice({
  name: 'pageEditorCanvas',
  initialState,
  reducers: {
    setModelDataRowPosition(state, action) {
      state.modelDataRowPosition = action.payload?.modelDataRowPosition;
    },
    setModelDataRow(state, action) {
      state.modelDataRow = action.payload?.modelDataRow;
    },
    setPageIsLoading(state, action) {
      state.isloading = action?.payload?.isloading;
    },
    showAppTheme(state, action) {
      state.displayAppTheme = action.payload;
    },
    setShowThemePreview(state, action) {
      state.showThemePreview = action.payload;
    },
    updateCustomThemeList(state, action) {
      state.customThemeList = action.payload;
    },
    updateSelectedThemeDtls(state, action) {
      state.selectedThemeDtls = action.payload;
    },
    updateSelectedWidget(state, action) {
      state.selectedWidget = action.payload;
    },
    updateCurrentPageDtls(state, action) {
      if (action?.payload === null) {
        state.currentPageDtls = action?.payload;
      } else {
        const currentPageDetails=state?.currentPageDtls||{}
        state.currentPageDtls = {
          ...currentPageDetails,
          ...action?.payload,
          pageHeight: action?.payload?.pageHeight ?
            state?.currentPageDtls?.pageHeight &&
            state?.currentPageDtls?.pageHeight > action?.payload?.pageHeight
              ? state?.currentPageDtls?.pageHeight
              : action?.payload?.pageHeight
              :state?.currentPageDtls?.pageHeight,
          tabLandscapePageHeight:action?.payload?.tabLandscapePageHeight?
            state?.currentPageDtls?.tabLandscapePageHeight &&
            state?.currentPageDtls?.tabLandscapePageHeight > action?.payload?.tabLandscapePageHeight
              ? state?.currentPageDtls?.tabLandscapePageHeight
              : action?.payload?.tabLandscapePageHeight
              :state?.currentPageDtls?.tabLandscapePageHeight,
          tabPotraitPageHeight:action?.payload?.tabPotraitPageHeight ?
            state?.currentPageDtls?.tabPotraitPageHeight &&
            state?.currentPageDtls?.tabPotraitPageHeight > action?.payload?.tabPotraitPageHeight
              ? state?.currentPageDtls?.tabPotraitPageHeight
              : action?.payload?.tabPotraitPageHeight
              :state?.currentPageDtls?.tabPotraitPageHeight,
          mobilePageHeight:action?.payload?.mobilePageHeight ?
            state?.currentPageDtls?.mobilePageHeight &&
            state?.currentPageDtls?.mobilePageHeight > action?.payload?.mobilePageHeight
              ? state?.currentPageDtls?.mobilePageHeight
              : action?.payload?.mobilePageHeight
              :state?.currentPageDtls?.mobilePageHeight,
        };
      }
    },
    updateActivePageDtls(state, action) {
      state.currentPageDtls = { ...state?.currentPageDtls, ...action.payload };
    },
    updateUndoRedoStepValue(state, action) {
      const prevUndoStepValue = state.currentPageDtls.undoStepValue;
      const reqVal = action?.payload;
      state.currentPageDtls.undoStepValue =
        reqVal?.undoStepValue === 'incrementBy1'
          ? prevUndoStepValue + 1
          : reqVal?.undoStepValue === 'setToZero'
          ? 0
          : reqVal?.undoStepValue;
      state.currentPageDtls.redoStepValue =
        reqVal?.redoStepValue === 'setToZero' ? 0 : reqVal?.redoStepValue;
    },
    updateErrormsg(state, action) {
      state.errorMessage = action.payload;
    },
    updateSuccessmsg(state, action) {
      state.successMessage = action.payload;
    },
    updateFailuremsg(state, action) {
      state.failureMessage = action.payload;
    },
    updateActionFlowList(state, action) {
      state.actionFlowList = action.payload;
    },
    updateActionFlowOutputParm(state, action) {
      state.actionFlowOutputParamsList = action.payload;
    },
    updateResourceAppConstants(state, action) {
      state.resourceAppConstants = action.payload;
    },
    updateUserProfile(state, action) {
      state.userProfile = action.payload;
    },
    updateShowNestedDropdownMenu(state, action) {
      state.showNestedMenu = action.payload;
    },
    updateShowPreSelectedDropdownMenu(state, action) {
      state.showPreSelectedNestedMenu = action.payload;
    },
    updateApplicationDetails(state, action) {
      state.applicationDetails = action.payload;
    },
    setDevice(state, action) {
      state.device = action.payload;
    },
    updateSelectedThemeId(state, action) {
      state.selectedThemeId = action.payload;
    },
    // updateShowSidebar(state, action) {
    //   state.showSidebar = action.payload;

    updateShowRightSidebar(state, action) {
      state.showRightSidebar = action.payload;
    },
    updateShowLeftSidebar(state, action) {
      state.showLeftSidebar = action.payload;
    },
    updateDefaultCanvasHeight(state, action) {
      state.defaultCanvasHeight = action.payload;
    },
    // updateDefaultCanvasWidth(state, action) {
    //   state.defaultCanvasWidth = action.payload;
    // },
    // updateLeftRightWidth(state, action) {
    //   state.leftRightWidth = action.payload;
    // },
    updateLeftSidebarWidth(state, action) {
      state.leftSidebarWidth = action.payload;
    },
    updateRightSidebarWidth(state, action) {
      state.rightSidebarWidth = action.payload;
    },
    updateCurrentCanvasWidth(state, action) {
      state.currentCanvasWidth = action.payload;
    },    
   resetPageEditorCanvas(state) {
    state.readOnly=initialState.readOnly
      state.pageEditorModelData = initialState.pageEditorModelData;
      state.modelDataRowPosition = initialState.modelDataRowPosition;
      state.modelDataRow = initialState.modelDataRow;
      state.pageEditorModelData1 = initialState.pageEditorModelData1;
      state.displayAppTheme = initialState.displayAppTheme;
      state.showThemePreview = initialState.showThemePreview;
      state.customThemeList = initialState.customThemeList;
      state.selectedThemeDtls = initialState.selectedThemeDtls;
      state.selectedWidget = initialState.selectedWidget;
      state.currentPageDtls = initialState.currentPageDtls;
      state.errorMessage = initialState.errorMessage;
      state.successMessage = initialState.successMessage;
      state.failureMessage = initialState.failureMessage;
      state.actionFlowList = initialState.actionFlowList;
      state.actionFlowOutputParamsList = initialState.actionFlowOutputParamsList;
      state.resourceAppConstants = initialState.resourceAppConstants;
      state.userProfile = initialState.userProfile;
      state.showNestedMenu = initialState.showNestedMenu;
      state.showPreSelectedNestedMenu = initialState.showPreSelectedNestedMenu;
      state.applicationDetails = initialState.applicationDetails;
      state.device = initialState.device;
      state.selectedThemeId = initialState.selectedThemeId;
      state.showSidebar = initialState.showSidebar;
      state.showLeftSidebar = initialState.showLeftSidebar;
      state.showRightSidebar = initialState.showRightSidebar;
      state.defaultCanvasHeight = initialState.defaultCanvasHeight;
      state.defaultCanvasWidth = initialState.defaultCanvasWidth;
      state.leftRightWidth = initialState.leftRightWidth;
      state.copyWidgetDtls = initialState.copyWidgetDtls;
      state.leftSidebarWidth= initialState.leftSidebarWidth;
      state.rightSidebarWidth= initialState.rightSidebarWidth;
      state.currentCanvasWidth=initialState.currentCanvasWidth;
      state.copyWidgetDtls=initialState.copyWidgetDtls;
      state.pageLock = initialState.pageLock;
      state.lnggTrnsltnNd=initialState.lnggTrnsltnNd;
      state.showCountryFlag=initialState.showCountryFlag;
      state.defLngg=initialState.defLngg;
      state.supLngg=initialState.supLngg;
      state.cookieEnabled=initialState.cookieEnabled;
      state.typeStrctData=initialState.typeStrctData;
      state.seoStrctDataType=initialState.seoStrctDataType;
      state.customSeoStrctData=initialState.customSeoStrctData;
      state.sitemapAdditionalUrls=initialState.sitemapAdditionalUrls;
      state.sitemapDynamicUrls=initialState.sitemapDynamicUrls;
      state.nameStrctData=initialState.nameStrctData;
      state.tlphnStrctData=initialState.tlphnStrctData;
      state.addrTypeStrctData=initialState.addrTypeStrctData;
      state.streetAddrStrctData=initialState.streetAddrStrctData;
      state.addrLcltyStrctData=initialState.addrLcltyStrctData;
      state.pstlCdeStrctData=initialState.pstlCdeStrctData;
      state.addrCuntyStrctData=initialState.addrCuntyStrctData;
      state.opngHrsStructData=initialState.opngHrsStructData;
      state.sameAsStructData=initialState.sameAsStructData;
      state.moreOption=initialState.moreOption;
    },
    updateCopyWidget(state, action) {
      state.copyWidgetDtls = action.payload;
    },
    updateZoomPercentage(state, action) {
      state.zoomPercentage = action.payload;
    },
    updateAppTitle(state, action) {
      state.appTitle = action.payload;
    },
    updateAppAliasName(state, action) {
      state.appAliasName = action.payload;
    },
    updatevalidCustomDomain(state, action) {
      state.validCustomDomain = action.payload;
    },
    updateSitemapDynamicUrls(state, action) {
      state.sitemapDynamicUrls = action.payload;
    },
    updateAppDescription(state, action) {
      state.appDescription = action.payload;
    },
    updateAppKeywords(state, action) {
      state.appKeywords = action.payload;
    },
     updateAppFavicon(state, action) {
      state.appFavicon = action.payload;
    },
    updateCoverImage(state, action) {
      state.coverImage = action.payload;
    },
    updateGoogleAnalyticsId(state, action) {
      state.gglAnlytcsMsrmntId = action.payload;
    },
    updateGoogleTagManagerId(state, action) {
      state.gglTagMngrId = action.payload;
    },
    updateFacebookAnalyticsId(state, action) {
      state.fbPixelId = action.payload;
    },
    updateGoogleAdsPublisherId(state, action) {
      state.gglAdsPublisherId = action.payload;
    },
    updateGoogleAdsAdUnitId(state, action) {
      state.gglAdUnitId = action.payload;
    },
    updatefreeDomain(state, action) {
      state.freeDomain = action.payload;
    },
    updatefreeDomainReadOnly(state, action) {
      state.freeDomainReadOnly = action.payload;
    },
    updatecustomDomain(state, action) {
      state.customDomain = action.payload;
    },
    updatecustomDomainReadOnly(state, action) {
      state.customDomainReadOnly = action.payload;
    },
    updateVisiblePopup(state, action) {
      state.visiblePopup = action.payload;
    },
    updateVisiblePopover(state, action) {
      state.visiblePopover = action.payload;
    },
    updatePopoverMonitor(state, action) {
      //console.log('popoverMonitor', action)
      state.popoverMonitor = action.payload;
    },
    updateShowMoreAppTempGroupName(state, action) {
      state.showMoreAppTempGroupName = action.payload;
    },
    updateDeployModel(state, action) {
      state.deployModel = action.payload;
    },
    updateAppModel(state, action) {
      state.appModel = action.payload;
    },
    updateFilteredWidget(state, action) {
      state.filteredWidget = action.payload;
    },
    updateSearchWidgetName(state, action) {
      state.searchWidgetName = action.payload;
    },
    updatePageLock(state) {
      state.pageLock = !state.pageLock;
    },
    updateLanguageTranslateNeeded(state, action) {
      state.lnggTrnsltnNd = action.payload;
    },
     updateLanguageCountryFlag(state, action) {
      state.showCountryFlag = action.payload;
    },    
    updateDefaultLanguage(state,action){
      state.defLngg = action.payload; 
    },
    updateSupportedLanguage(state,action){
      state.supLngg = action.payload; 
    },
    updateCanonicalUrlInfo(state, action) {
      state.canonicalUrlInfo = action.payload;
    },
    updateCookieEnabled(state, action) {
      state.cookieEnabled = action.payload;
    },
    updateSeoStrctDataType(state, action) {
      state.seoStrctDataType = action.payload;
    },
    updateCustomSeoStrctData(state, action) {
      state.customSeoStrctData = action.payload;
    },
    updateSitemapAdditionalUrls(state, action) {
      state.sitemapAdditionalUrls = action.payload;
    },
    updateSeoTypeStrctData(state, action) {
      state.typeStrctData = action.payload;
    },
    updateSeoNameStrctData(state, action) {
      state.nameStrctData = action.payload;
    },
    updateSeoTlphnStrctData(state, action) {
      state.tlphnStrctData = action.payload;
    },
    updateSeoAddrStrctData(state, action) {
      state.addrTypeStrctData = action.payload;
    },
    updateSeoStreetAddrStrctData(state, action) {
      state.streetAddrStrctData = action.payload;
    },
    updateSeoAddrLcltyStrctData(state, action) {
      state.addrLcltyStrctData = action.payload;
    },
    updateSeoPstlCdeStrctData(state, action) {
      state.pstlCdeStrctData = action.payload;
    },
    updateSeoAddrCuntyStrctData(state, action) {
      state.addrCuntyStrctData = action.payload;
    },    
    updateSeoOpngHrsStrctData(state, action) {
      state.opngHrsStructData = action.payload;
    },
    updateSeoSameAsStrctData(state, action) {
      state.sameAsStructData = action.payload;
    },
    updateMoreOption(state) {
      state.moreOption = !state.moreOption;
    },
    updateReadOnly(state, action) {
  state.readOnly = action.payload;
}

    
  },
});

const { reducer, actions } = pageEditorCanvasSlice;

export const {
  setModelDataRowPosition,
  setModelDataRow,
  showAppTheme,
  setShowThemePreview,
  updateCustomThemeList,
  updateSelectedThemeDtls,
  updateSelectedWidget,
  updateCurrentPageDtls,
  updateActivePageDtls,
  updateUndoRedoStepValue,
  updateErrormsg,
  updateSuccessmsg,
  updateFailuremsg,
  updateActionFlowList,
  updateActionFlowOutputParm,
  updateResourceAppConstants,
  updateUserProfile,
  updateApplicationDetails,
  setDevice,
  updateSelectedThemeId,
  updateShowSidebar,
  updateShowRightSidebar,
  updateShowLeftSidebar,
  updateDefaultCanvasHeight,
  //updateDefaultCanvasWidth,
 // updateLeftRightWidth,
  resetPageEditorCanvas,
  updateCopyWidget,
  updateZoomPercentage,
  updateShowNestedDropdownMenu,
  updateShowPreSelectedDropdownMenu,
  updateAppTitle,
  updateAppAliasName,
  updatevalidCustomDomain,
  updateSitemapDynamicUrls,
  updateAppDescription,
  updateAppKeywords,
  updateCoverImage,
  updateAppFavicon,
  updateVisiblePopup,
  updateVisiblePopover,
  updatePopoverMonitor,
  updateShowMoreAppTempGroupName,
  updateGoogleAnalyticsId,
  updateGoogleTagManagerId,
  updateFacebookAnalyticsId,
  updateGoogleAdsPublisherId,
  updateGoogleAdsAdUnitId,
  updatefreeDomain,
  updatefreeDomainReadOnly,
  updatecustomDomain,
  updatecustomDomainReadOnly,
  updateLeftSidebarWidth,
  updateRightSidebarWidth,
  updateCurrentCanvasWidth,
  updateDeployModel,
  updateAppModel,
  updateFilteredWidget,
  updateSearchWidgetName,
  updatePageLock,
  updateLanguageTranslateNeeded,
  updateLanguageCountryFlag,
  updateDefaultLanguage,
  updateSupportedLanguage,
  updateCanonicalUrlInfo,
  updateCookieEnabled,
  updateSeoStrctDataType,
  updateCustomSeoStrctData,
  updateSitemapAdditionalUrls,
  updateSeoTypeStrctData,
  updateSeoNameStrctData,
  updateSeoTlphnStrctData,
  updateSeoAddrStrctData,
  updateSeoStreetAddrStrctData,
  updateSeoAddrLcltyStrctData,
  updateSeoPstlCdeStrctData,
  updateSeoAddrCuntyStrctData,
  updateSeoOpngHrsStrctData,
  updateSeoSameAsStrctData,
  updateMoreOption,
  updateReadOnly
} = actions;
export default reducer;
